import {useCallback, useState} from 'react';

/** One accordion item open at a time (FAQ sections): clicking the open one closes it, clicking another switches to it. */
export const useOpenItem = () => {
    const [open, setOpen] = useState<number | false>(false);
    const toggle = useCallback((index: number) => {
        setOpen((current) => (current === index ? false : index));
    }, []);
    return [open, toggle] as const;
};
